export default __webpack_public_path__ + "static/media/default-avatar.b39d8ea8.png";